/**
 * Vert AI wordmark, traced from the source PNG and inlined as SVG.
 * Uses currentColor so it inherits text color from the parent.
 * Eliminates the 47 KB PNG request — improves LCP.
 */
const VertLogo = ({ className = "", title = "Vert AI" }: { className?: string; title?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2142.221703 498.742259"
    role="img"
    aria-label={title}
    className={className}
    preserveAspectRatio="xMidYMid meet"
  >
    <g transform="translate(-94.779274,638.000000) scale(0.100000,-0.100000)"
fill="currentColor" stroke="none">
<path d="M18329 6273 c-28 -60 -56 -121 -64 -138 -7 -16 -32 -70 -55 -120 -23
-49 -62 -135 -87 -190 -25 -55 -58 -129 -75 -165 -16 -36 -196 -427 -398 -870
-202 -443 -382 -834 -398 -870 -17 -36 -52 -114 -80 -175 -27 -60 -63 -139
-80 -175 -16 -36 -64 -139 -105 -230 -41 -91 -89 -194 -105 -230 -17 -36 -50
-110 -75 -165 -25 -55 -63 -138 -85 -185 -65 -141 -102 -221 -102 -224 0 -2
-22 -50 -49 -107 -63 -134 -111 -240 -111 -243 0 -2 -25 -57 -56 -122 -30 -66
-61 -132 -69 -149 -32 -73 -70 -156 -106 -234 -22 -46 -39 -88 -39 -92 0 -5
117 -9 261 -9 l260 0 31 68 c37 82 53 117 113 252 76 170 193 429 248 550 14
30 46 102 72 160 26 58 60 133 76 168 16 35 29 68 29 73 0 5 520 9 1340 9
l1340 0 24 -52 c13 -29 88 -195 166 -368 78 -173 155 -343 171 -378 16 -35 29
-65 29 -67 0 -2 16 -39 36 -82 71 -153 91 -199 110 -245 38 -95 14 -89 311
-86 l262 3 -40 90 c-23 50 -55 119 -71 155 -17 36 -53 115 -80 175 -28 61 -63
139 -80 175 -16 36 -160 349 -318 695 -158 347 -302 659 -318 695 -17 36 -50
110 -75 165 -25 55 -63 138 -85 185 -22 47 -50 108 -62 135 -27 61 -132 291
-216 473 -19 41 -34 75 -34 76 0 2 -25 57 -56 122 -56 120 -62 134 -107 234
-13 30 -41 91 -62 135 -67 144 -95 206 -95 209 0 2 -25 57 -56 122 -30 66 -61
133 -69 149 -14 31 -54 119 -104 228 -15 34 -39 85 -51 112 -52 115 -106 233
-160 350 -18 39 -36 80 -41 93 l-9 22 -250 0 -251 0 -50 -107z m325 -488 c14
-31 26 -57 26 -60 0 -2 15 -36 34 -77 18 -40 50 -111 71 -158 21 -47 53 -118
71 -158 19 -41 34 -75 34 -77 0 -2 13 -32 29 -67 26 -55 102 -224 246 -548 97
-216 177 -395 194 -434 11 -22 58 -129 106 -236 48 -107 100 -223 116 -258 16
-35 29 -65 29 -67 0 -2 18 -43 40 -90 22 -47 40 -88 40 -90 0 -2 18 -43 40
-90 22 -47 40 -88 40 -91 0 -2 -516 -4 -1146 -4 l-1145 0 7 23 c4 12 24 59 45
105 22 46 39 85 39 87 0 2 18 43 40 90 22 47 40 88 40 90 0 2 18 43 40 90 22
47 40 88 40 90 0 2 13 32 29 67 16 35 45 98 65 141 20 43 36 80 36 82 0 2 18
43 40 90 22 47 40 88 40 90 0 2 15 36 34 77 18 40 50 111 71 158 21 47 53 118
71 158 19 41 34 75 34 77 0 2 15 36 34 77 18 40 68 152 111 248 43 96 92 207
110 245 17 39 72 161 121 272 49 111 92 203 95 203 4 0 18 -25 33 -55z"/>
<path d="M21870 6375 c0 -3 0 -1078 0 -2390 0 -1312 0 -2389 0 -2395 0 -6 90
-10 250 -10 l250 0 0 2390 c0 1315 0 2393 0 2398 0 4 -112 8 -250 10 -137 1
-250 0 -250 -3z"/>
<path d="M954 6305 c4 -14 20 -56 37 -93 17 -36 53 -120 81 -187 28 -66 64
-149 80 -185 17 -36 46 -103 65 -150 33 -79 60 -140 103 -235 10 -22 41 -95
69 -162 27 -66 63 -149 79 -184 16 -35 52 -118 80 -184 27 -66 61 -145 75
-175 14 -30 57 -131 97 -225 40 -93 82 -192 95 -220 12 -27 48 -111 80 -185
31 -74 68 -160 82 -190 14 -30 48 -109 75 -175 28 -66 64 -149 80 -184 16 -35
51 -116 78 -181 27 -65 62 -146 78 -181 16 -35 53 -120 81 -188 29 -69 61
-143 71 -165 30 -65 470 -1087 470 -1091 0 -2 13 -32 29 -67 16 -35 47 -103
68 -153 l39 -90 560 -3 560 -2 23 52 c13 29 111 256 218 503 107 248 203 468
213 490 10 22 37 85 60 140 23 55 55 127 70 160 15 33 43 98 63 145 32 77 55
131 107 245 9 22 33 78 53 125 19 47 49 117 67 155 18 39 48 108 67 155 20 47
44 103 53 125 43 95 70 156 110 250 23 55 51 119 61 141 10 23 100 230 200
460 99 231 187 433 194 449 8 17 44 100 80 185 37 85 75 173 85 195 10 22 37
85 60 140 23 55 56 129 72 165 17 36 46 103 65 150 32 76 58 137 98 226 46
100 85 198 85 210 0 12 -81 14 -557 12 l-557 -3 -257 -595 c-142 -327 -268
-617 -280 -645 -12 -27 -48 -113 -81 -190 -33 -77 -70 -162 -83 -190 -12 -27
-41 -95 -65 -150 -42 -101 -49 -116 -93 -215 -13 -30 -43 -100 -67 -155 -44
-104 -51 -120 -95 -220 -15 -33 -43 -98 -62 -145 -20 -47 -48 -112 -63 -145
-15 -33 -46 -105 -70 -160 -44 -104 -51 -120 -95 -220 -15 -33 -43 -98 -62
-145 -20 -46 -45 -107 -58 -135 -12 -27 -33 -74 -45 -103 -13 -29 -28 -51 -33
-49 -5 1 -54 108 -108 237 -55 129 -103 244 -109 255 -19 43 -55 125 -174 408
-68 161 -133 315 -145 342 -13 28 -28 64 -36 80 -7 17 -68 161 -135 320 -114
269 -178 421 -200 470 -24 54 -57 131 -160 375 -62 146 -120 283 -130 305 -26
61 -43 101 -169 396 l-116 274 -609 3 -608 2 6 -25z"/>
<path d="M13558 5573 l-3 -458 -287 -3 -288 -2 0 -415 0 -415 288 -2 287 -3 6
-895 c3 -492 9 -908 13 -925 4 -16 14 -62 22 -102 73 -375 287 -656 619 -814
171 -82 335 -122 566 -141 264 -20 579 15 787 88 112 40 272 125 272 146 0 9
-280 749 -286 757 -1 2 -30 -13 -63 -33 -137 -84 -311 -117 -467 -91 -196 33
-315 142 -359 327 -12 53 -15 194 -15 876 l0 812 465 0 465 0 0 415 0 415
-465 0 -465 0 -2 458 -3 457 -542 3 -543 2 -2 -457z"/>
<path d="M7772 5249 c-516 -30 -959 -218 -1300 -553 -460 -450 -653 -1110
-522 -1781 111 -570 470 -1028 1013 -1294 245 -120 524 -194 829 -222 150 -13
499 -4 648 17 465 66 812 228 1088 507 l74 74 -138 149 c-75 82 -185 201 -243
264 -58 63 -127 137 -152 164 l-46 49 -74 -62 c-138 -116 -303 -204 -459 -244
-115 -30 -159 -37 -291 -47 -269 -20 -532 29 -728 136 -158 87 -276 198 -358
337 -44 75 -103 223 -103 259 0 17 76 18 1418 20 l1417 3 12 145 c20 243 -7
518 -73 751 -85 299 -227 547 -442 770 -180 188 -392 326 -657 426 -203 77
-396 118 -605 128 -69 3 -136 7 -150 9 -14 1 -85 -1 -158 -5z m403 -848 c283
-76 508 -273 606 -531 19 -49 59 -193 59 -212 0 -9 -1834 -11 -1842 -3 -8 9
29 159 57 227 92 226 277 407 500 488 133 49 215 60 405 54 99 -2 167 -10 215
-23z"/>
<path d="M12640 5249 c-110 -6 -216 -22 -395 -59 -121 -25 -337 -120 -460
-203 -75 -51 -169 -136 -231 -210 -27 -31 -52 -57 -56 -57 -4 0 -8 108 -8 240
l0 240 -517 -2 -518 -3 -3 -1872 -2 -1873 545 0 545 0 0 933 c0 968 3 1054 43
1207 97 365 330 581 707 655 87 17 407 24 463 10 l27 -7 0 500 c0 276 -3 502
-7 504 -5 2 -64 1 -133 -3z"/>
</g>
  </svg>
);

export default VertLogo;
